import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#date-picker" }),
    /*#__PURE__*/_createTextVNode(" DatePicker ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Use Date Picker for date input. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIEnterDate = _resolveComponent("EUIEnterDate")
  const _component_EUIOtherMeasurements = _resolveComponent("EUIOtherMeasurements")
  const _component_EUIDateRange = _resolveComponent("EUIDateRange")
  const _component_EUIMonthRange = _resolveComponent("EUIMonthRange")
  const _component_EUIDefaultValue = _resolveComponent("EUIDefaultValue")
  const _component_EUIDateFormats = _resolveComponent("EUIDateFormats")
  const _component_EUIDefaultTimeForStartDateAndEndDate = _resolveComponent("EUIDefaultTimeForStartDateAndEndDate")
  const _component_EUILocalization = _resolveComponent("EUILocalization")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIEnterDate),
    _createVNode(_component_EUIOtherMeasurements),
    _createVNode(_component_EUIDateRange),
    _createVNode(_component_EUIMonthRange),
    _createVNode(_component_EUIDefaultValue),
    _createVNode(_component_EUIDateFormats),
    _createVNode(_component_EUIDefaultTimeForStartDateAndEndDate),
    _createVNode(_component_EUILocalization)
  ], 64))
}